var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CardShell',[_c('DisplayToolCore',{attrs:{"tool":_vm.listing,"route":'/search' + (_vm.query ? '?q=' + _vm.query : ''),"linkText":"Search Results"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }